export const BACK_BUTTON_SLOT_WIDTH = 67

export const pageHeaderBackButton = theme => ({
  minWidth: 40,
  width: 40,
  height: 40,
  padding: 0,
  borderRadius: '50%',
  color: theme.palette.text.secondary,
  backgroundColor: 'transparent',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#F5F5F5',
    boxShadow: 'none',
  },
})

export const pageHeaderHorizontalPadding = theme => ({
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(3),
  [theme.breakpoints.down('xs')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
})

export const pageHeaderLabelColumn = (theme, hasCrumbs) => ({
  minWidth: 0,
  paddingLeft: hasCrumbs ? theme.spacing(2) : 0,
  [theme.breakpoints.down('xs')]: {
    paddingLeft: theme.spacing(2),
  },
})

export const pageHeaderGridColumns = hasCrumbs =>
  hasCrumbs ? `${BACK_BUTTON_SLOT_WIDTH}px minmax(0, 1fr)` : 'minmax(0, 1fr)'

export const pageHeaderGridColumnsWithActions = hasCrumbs =>
  hasCrumbs
    ? `${BACK_BUTTON_SLOT_WIDTH}px minmax(0, 1fr) auto`
    : 'minmax(0, 1fr) auto'

export const pageHeaderLabelColumnIndex = hasCrumbs => (hasCrumbs ? 2 : 1)

export const pageHeaderActionsColumnIndex = hasCrumbs => (hasCrumbs ? 3 : 2)
